<div id="map"></div>

<legend-dialog
	id="legendMenu"
	class="legend" 
	style="display:none">
</legend-dialog> 

<p-dialog header="Station Status" [(visible)]="showStationDetails" position="bottom-right">
	<div [innerHTML]=stationDetails></div>
	<button class="popupButton" (click)="gotoDetailForCurrentStationId()">Go to Station Dashboard</button>
</p-dialog>

<!-- PrimeNG Galleria for displaying images --> 
<!-- 
			[responsiveOptions]="mapService.responsiveOptions"
-->
<p-dialog header="Camera Images"
	[(visible)]="mapService.displayImages">
	<p-galleria [value]="mapService.images"
			[(activeIndex)]="mapService.activeIndex"
			[showItemNavigators]="true"
			[containerStyle]="{'max-width': '1000px'}">
		<!-- images -->
		<ng-template pTemplate="item" let-item>
      <img *ngIf="item!=null" [src]="item.image"
			 	style="width: 100%; display: block;"
				[alt]="item.name" />
		</ng-template>

		<!-- thumbnails -->
		<ng-template pTemplate="thumbnail" let-item>
			<div class="grid grid-nogutter justify-content-center">
				<img [src]="item.image" style="max-height: 200px" />
			</div>
		</ng-template>

		<!-- footer -->
		<ng-template pTemplate="footer" let-item>
            <div class="custom-galleria-footer">
                <span *ngIf="mapService.images" class="title-container">
                    <span>Image {{ mapService.activeIndex + 1 }}/{{ mapService.images.length }} </span>
                    <br>
                    <span *ngIf="mapService.images[mapService.activeIndex]?.link">
                        <a target="_blank" href={{mapService.images[mapService.activeIndex]?.link}} style="color: blue; text-decoration: underline" >
                            {{mapService.images[mapService.activeIndex]?.linkLabel || linkLabel }}</a>
                    </span>
                </span>
            </div>
        </ng-template>
	</p-galleria>
</p-dialog>
